import React, { useEffect, useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import { Grid } from "@material-ui/core";
import systemParameterService from "./systemParameterService";
import InputField from "../../componentes/form-fields/InputField/InputField";
import CustomAlert from "../../componentes/alerts/CustomAlert";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import icon_brazil from "../../images/icon_brazil.png";
import icon_uk from "../../images/icon_uk.png";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";


const columnsSystemParameter = (t) => [
  { field: "id", visible: false },
  {
    field: "parameter",
    headerTemplate: () => {
      return <IconLabelSwitch isHeader={true} labelName="parameter" />;
    },
    flex: 1
  },
  {
    field: "valueDescription",
    flex: 1,
    headerTemplate: () => {
      return <IconLabelSwitch isHeader={true} labelName="status" />;
    },
    template: (props) => {
      switch (props.type) {
        case 0:
          return props.value ? <IconSwitch name="yes" /> : <IconSwitch name="no" />
        case 1:
          return props.numeralValue
        case 2:
          return t(props.textValue)
      }
    },
  }
];

function reducer(state, action) {
  switch (action.type) {
    case 'update':
      return { ...state, ...action.data }
    case "clear":
      return initialSystemParameterState
    case "clearFields":
      return { ...initialSystemParameterState, systemParameterRows: state.systemParameterRows }
    case 'success':
      return { ...state, success: true, error: false }
    case 'error':
      return { ...state, success: false, error: true }
    case 'close_alert':
      return { ...state, success: false, error: false }
    default:
      return new Error();
  }
}

const initialSystemParameterState = {
  idParameter: 0,
  type: 3,
  value: 2,
  numeralValue: "",
  textValue: "",
  success: false,
  error: false,
  alertMessage: "",
  systemParameterRows: [],
  isParamChanged: undefined,
  isLanguage: false,
};

export default function SystemParameter() {
  const { t } = useTranslation();
  const { control } = useForm();


  const [systemParameter, dispatch] = useReducer(reducer, initialSystemParameterState);
  const { idParameter, type, value, numeralValue, textValue, success, error, alertMessage, systemParameterRows, isParamChanged, isLanguage } = systemParameter

  const handleSearch = () => {
    systemParameterService
      .get({
        id: 0,
        parameter: "",
        type: 0,
        value: "",
        numeralValue: "",
      })
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'update',
            data: { systemParameterRows: response.data }
          });
        }
      })
      .catch((e) => { });
  };

  useEffect(() => {
    handleSearch();
  }, []);

  const handleChange = ({ target: { name, value, contextKey } }) => {
    if (name === "idParameter") {
      if (isParamChanged === undefined) {
        dispatch({
          type: 'update',
          data: { isParamChanged: true, [name]: value, isLanguage: contextKey === "DEFAULT_LANGUAGE" ? true : false }
        });
      } else {
        dispatch({
          type: 'update',
          data: { isParamChanged: !isParamChanged, [name]: value, isLanguage: contextKey === "DEFAULT_LANGUAGE" ? true : false }
        });
      }
    } else {
      dispatch({
        type: 'update',
        data: { [name]: value }
      });
    }
  };

  useEffect(() => {
    if (isParamChanged !== undefined && systemParameterRows && systemParameterRows.length > 0 && idParameter !== "") {
      const selectedSystemParam = systemParameterRows.find(
        (x) => x.id === idParameter
      );
      const {
        id,
        parameter,
        valueDescription,
        ...dataSpread
      } = selectedSystemParam;
      dataSpread.idParameter = id;
      dispatch({
        type: 'update',
        data: { ...dataSpread }
      })
    }
    if (isParamChanged !== undefined && systemParameterRows && systemParameterRows.length > 0 && idParameter === "") {
      dispatch({
        type: 'clearFields',
      })
    }
  }, [isParamChanged]);

  const canSave = () => {
    if (idParameter > 0) {
      if (systemParameter.type === 1) {
        return systemParameter.numeralValue;
      }
      return true;
    }
    return false;
  };

  const saveSystemParameter = () => {
    dispatch({
      type: 'update',
      data: { alertMessage: t("checkFields") }
    })
    if (canSave()) {
      const { idParameter, isLanguage, ...newData } = systemParameter;
      newData.id = idParameter;

      systemParameterService
        .update(newData)
        .then((response) => {
          if (response.status === 200) {
            dispatch({ type: 'success' })
            handleSearch();
          }
        })
        .catch((e) => dispatch({
          type: 'error'
        }));
    } else {
      dispatch({
        type: 'update',
        data: { alertMessage: t("checkFields"), error: true, success: false }
      })
    }
  };

  const selectedSystemParameterChanged = (data) => {
    const { id, parameter, valueDescription, ...dataSpread } = data;
    dataSpread.idParameter = id;

    dispatch({
      type: 'update',
      data: { ...dataSpread, isLanguage: parameter === 'Localização Inicial' ? true : false }
    })
  };

  return (
    <>
      <DefaultScreenAccordion
        title="systemParameters"
        isConsult
        fields={
          <GridItemContainer>
            <CustomAlert
              message={alertMessage}
              success={success}
              error={error}
              handleCloseAlert={() => dispatch({ type: 'close_alert' })}
            />
            <GridInputRow>
              <Grid item xs={12} sm={6}>
                <DefaultAutocomplete
                  name={"idParameter"}
                  onChange={handleChange}
                  value={idParameter}
                  label={t("idParameter")}
                  defaultSize
                  useApi
                  endpoint='GetSystemParameterListAutoComplete'
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <DefaultAutocomplete
                  name={"type"}
                  onChange={handleChange}
                  value={type}
                  label={t("type")}
                  defaultSize
                  items={[
                    { id: 0, name: t("yesNo"), status: 1 },
                    { id: 1, name: t("numeral"), status: 1 },
                    { id: 2, name: t("text"), status: 1 },
                    { id: 3, name: t("select"), status: 1 },
                  ]}
                />
              </Grid>
              {systemParameter.type === 0 &&
                <Grid item xs={6} md={3}>
                  <DefaultAutocomplete
                    name={"value"}
                    onChange={handleChange}
                    value={value}
                    label={t("value")}
                    defaultSize
                    items={[
                      { id: 0, name: t("no"), status: 1 },
                      { id: 1, name: t("yes"), status: 1 },
                      { id: 2, name: t("select"), status: 1 },
                    ]}
                  />
                </Grid>
              }
              {systemParameter.type === 1 &&
                <Grid item xs={3}>
                  <InputField
                    name="numeralValue"
                    type="number"
                    control={control}
                    error={error && numeralValue === ""}
                    onChange={(event) => {
                      if (event.target.value < 0) {
                        event.target.value = "";
                      }
                      handleChange(event);
                    }}
                    value={numeralValue} />
                </Grid>}
              {systemParameter.type === 2 && isLanguage &&
                <Grid item xs={3}>
                  <DefaultAutocomplete
                    name={"textValue"}
                    onChange={handleChange}
                    value={textValue}
                    label={t("location")}
                    defaultSize
                    useImage
                    items={[
                      { id: 'ptBR', name: "Portuguese", img: icon_brazil, status: 1 },
                      // { id: 'en', name: "English", img: icon_uk, status: 1 },
                    ]}
                  />
                </Grid>}
              {systemParameter.type === 2 && !isLanguage &&
                <Grid item xs={3}>
                  <InputField
                    name="textValue"
                    control={control}
                    error={error && textValue === ""}
                    onChange={handleChange}
                    value={textValue} />
                </Grid>}
            </GridInputRow>
            <SearchClearSaveRow
              onClickSave={saveSystemParameter}
            />
          </GridItemContainer>
        }
      />
      {systemParameterRows.length > 0 ? (
        <DefaultScreenAccordion
          fields={
            <Grid item xs={12}>
              <DefaultDatagrid
                dataSource={systemParameterRows}
                columns={columnsSystemParameter(t)}
                allowPaging={true}
                cellSelected={(args) => { selectedSystemParameterChanged(args.data); }}
              />
            </Grid>
          } />
      ) : null}
    </>
  );
};
